import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
//import reportWebVitals from './reportWebVitals';

import { initializeIcons } from '@fluentui/font-icons-mdl2';

import { configService } from './services/configService';
import { Localized } from './utilities/localizedStrings';
import App from './App';
import { initMsAuth } from './authProviders/microsoft';

initializeIcons();

configService.loadConfig().then(async function (config) {
    if (config) {
        await initMsAuth();

        Localized.loadLang(Localized.lang).then((_langJson) => {
            ReactDOM.render(
                <React.StrictMode>
                    <App />
                </React.StrictMode>,
                document.getElementById('root')
            );
        });
    } else {
        ReactDOM.render(
            <div>Ooops!</div>,
            document.getElementById('root')
        );
    }
});


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
